import { c as _c } from "react/compiler-runtime";
import type { ChatSessionResponse } from '@onefootprint/request-types/dashboard';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInterval } from 'usehooks-ts';
import type { BrowserRunSegment } from '../../utils/chat-segments';
import { ToolCallGroup } from '../tool-call-group';
type BrowserRunProps = {
  segment: BrowserRunSegment;
  session: ChatSessionResponse;
  toolResults?: Record<string, string>;
  toolErrors?: Record<string, boolean>;
};
const BrowserRun = t0 => {
  const $ = _c(20);
  const {
    segment,
    session,
    toolResults,
    toolErrors
  } = t0;
  const {
    t
  } = useTranslation("copilot");
  const [now, setNow] = useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setNow(Date.now());
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useInterval(t1, segment.open ? 1000 : null);
  const startedAt = Date.parse(segment.messages[0].timestamp);
  const lastMessage = segment.messages[segment.messages.length - 1];
  let t2;
  if ($[1] !== lastMessage || $[2] !== now || $[3] !== segment.endedAt || $[4] !== segment.open) {
    t2 = segment.open ? now : Date.parse(segment.endedAt ?? lastMessage.timestamp);
    $[1] = lastMessage;
    $[2] = now;
    $[3] = segment.endedAt;
    $[4] = segment.open;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const finishedAt = t2;
  let t3;
  if ($[6] !== finishedAt || $[7] !== startedAt) {
    t3 = Math.round((finishedAt - startedAt) / 1000);
    $[6] = finishedAt;
    $[7] = startedAt;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const seconds = Math.max(0, t3);
  let t4;
  if ($[9] !== seconds || $[10] !== segment.open || $[11] !== t) {
    t4 = segment.open ? t(_temp2, {
      seconds
    }) : t(_temp3, {
      seconds
    });
    $[9] = seconds;
    $[10] = segment.open;
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const summary = t4;
  let t5;
  if ($[13] !== segment.messages || $[14] !== segment.open || $[15] !== session || $[16] !== summary || $[17] !== toolErrors || $[18] !== toolResults) {
    t5 = <ToolCallGroup messages={segment.messages} session={session} toolResults={toolResults} toolErrors={toolErrors} isThinking={segment.open} summary={summary} showNarration={true} />;
    $[13] = segment.messages;
    $[14] = segment.open;
    $[15] = session;
    $[16] = summary;
    $[17] = toolErrors;
    $[18] = toolResults;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
export default BrowserRun;
function _temp() {
  return Date.now();
}
function _temp2($) {
  return $.chat.browser.run.working;
}
function _temp3($_0) {
  return $_0.chat.browser.run.worked;
}